exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Open+Sans:300,300i,400,400i,600,700);", ""]);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Oswald:300,400,600,700);", ""]);

// module
exports.push([module.id, "body{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased}.no-select{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.project-header .avatar-info .avatar-info__box{left:-114px;top:28px}.avatar-info{margin-left:-7.5px;margin-bottom:10px}.field-user-task-details .avatar-info__box{left:-86px}.field-user-task-details .avatar-info__box .user-avatar.has-info .default-user-image-container .user-initials{left:-2px}.avatar-info{position:relative}.avatar-info .user-avatar.has-info{cursor:pointer;font-weight:600}.avatar-info .user-avatar.has-info .default-user-image-container{position:relative}.avatar-info .user-avatar.has-info.not-assigned{cursor:default}.avatar-info .user-image-container:hover{cursor:pointer}.assignment .avatar-info__box{top:32px}.assignment__left .avatar-info__box{left:-8px}.assignment__left .avatar-info__box:before{left:30px}.assignment__right .avatar-info__box{right:-8px;left:auto}.assignment__right .avatar-info__box:before{left:auto;right:30px}", ""]);

// exports
exports.locals = {
	"addGreen": "#4bb543",
	"inProgress": "#f5a623",
	"complete": "#5db348",
	"iconGrey": "#A4A4A4",
	"warmGreyTwo": "#9b9b9b",
	"gray": "#676767",
	"offBlack": "#2C2C2C",
	"lightElement": "#D8D8D8",
	"white": "#fff",
	"aoDarkBlue": "#184e78",
	"secondaryLabelFont": "#bababa",
	"nonExistant": "#9b9b9b",
	"red": "#D0011B"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/components/UserAvatar/UserAvatarWithInfo/UserAvatarWithInfo.scss
// module id = 1676
// module chunks = 0